<template>
	<div class="app">
		<Card dis-hover>
			<div class="page-body">
				<Form ref="queryForm" :label-width="90" label-position="right" inline>
					<Row :gutter="20">
						<Col span="4">
						<FormItem label="年份：" style="width: 100%">
							<DatePicker type="year" @on-change="params.year=$event" v-model="params.year"
								:editable="false" placeholder="请选择" />
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="客户简名：" style="width: 100%">
							<Select v-model="params.customerJM" placeholder="">
								<Option value="">---</Option>
								<Option v-for="(item, index) in customerJMList" :value="item.value" :key="index">
									{{ item.name }}
								</Option>
							</Select>
						</FormItem>
						</Col>
						<Col span="5">
						<FormItem label="业务员：" style="width: 100%">
							<Select v-model="params.salesman" placeholder="">
								<Option value="">---</Option>
								<Option v-for="(item, index) in salesmanList" :value="item.value" :key="index">
									{{ item.name }}
								</Option>
							</Select>
						</FormItem>
						</Col>
						<Button icon="ios-search" type="primary" size="default" @click="queryTab"
							class="toolbar-btn">{{ '查询' }}</Button>
						<Button @click="addSupperRow" icon="md-add" type="primary" size="default"
							class="toolbar-btn">添加</Button>
						<Button icon="md-archive" type="primary" size="default" @click="downLoadTemplate"
							class="toolbar-btn">下载导入模板</Button>
						<Upload :before-upload="beforeImportFile" :on-success="importFile" :on-error="errorImportFile"
							:headers="requestHeader" accept=".xlsx,.xls,.excel" :show-upload-list="false"
							:action="action" :data="importData">
							<Button icon="md-add" type="primary" size="default" class="toolbar-btn">导入数据</Button>
						</Upload>
						<Button type="success" icon="md-archive" @click="exportFile" class="toolbar-btn">导出</Button>
					</Row>
				</Form>
				<div v-if="list">
					<!-- ? TableRowAdd  Form嵌套住整个表格 使用行内规则-->
					<Form ref="formAddSupperRowObj" :model="addSupperRowObj" :label-width="10">
						<Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list">
							<!-- 数据 -->
							<!-- ? TableRowAdd 插槽内每个都需要单独判断 -->
							<!-- 客户简名  -->
							<template slot-scope="{ row, index }" slot="customerJM">
								<div class="formItemArea" v-if="isModeEdit(row)">
									<!-- ? TableRowAdd  编辑状态时显示输入框-->
									<FormItem prop="customerJM"
										:rules="{required: true, message: '请输入', trigger: 'blur'}">
										<!-- ? TableRowAdd  :transfer="true"使下拉弹窗不受父级影响 -->
										<Select v-model="addSupperRowObj.customerJM" :transfer="true" placeholder="请选择"
											@on-change="getInfo">
											<Option value="">---</Option>
											<Option v-for="(item, index) in customerJMList" :value="item.value"
												:key="index">
												{{ item.name }}
											</Option>
										</Select>
									</FormItem>
								</div>
								<div v-else>
									<!-- ? TableRowAdd  普通状态时显示文字-->
									{{ row.customerJM }}
								</div>
							</template>
							<!-- 业务员 -->
							<template slot-scope="{ row, index }" slot="salesmanText">
								<div class="formItemArea" v-if="isModeEdit(row)">
									<!-- ? TableRowAdd  编辑状态时显示输入框-->
									<FormItem prop="salesman"
										:rules="{required: true, message: '请选择', trigger: 'blur',type:'number'}">
										<Select v-model="addSupperRowObj.salesman" :transfer="true">
											<Option v-for="item in salesmanList" :value="item.value" :key="item.value">
												{{ item.name }}</Option>
										</Select>
										<!-- <Input type="text" placeholder="请输入" v-model="addSupperRowObj.salesmanText" disabled ></Input> -->
									</FormItem>
								</div>
								<div v-else>
									<!-- ? TableRowAdd  普通状态时显示文字-->
									{{ row.salesmanText }}
								</div>
							</template>
							<!-- 年份 -->
							<template slot-scope="{ row, index }" slot="year">
								<div class="formItemArea" v-if="isModeEdit(row)">
									<!-- ? TableRowAdd  编辑状态时显示输入框-->
									<FormItem prop="yearText"
										:rules="{required: true, message: '请选择', trigger: 'blur',type:'date'}">
										<DatePicker type="year" placeholder="请选择" :transfer="true"
											v-model="addSupperRowObj.yearText"></DatePicker>
										<!-- <DatePicker type="year" @on-change="addSupperRowObj.yearText=$event" :value="addSupperRowObj.yearText" :transfer="true" :editable="false" placeholder="请选择" style="width: 270px" /> -->
									</FormItem>
								</div>
								<div v-else>
									<!-- ? TableRowAdd  普通状态时显示文字-->
									{{ row.year }}
								</div>
							</template>

							<!-- 销售预估 -->
							<template slot-scope="{ row, index }" slot="salesForecastText">
								<div class="formItemArea" v-if="isModeEdit(row)">
									<!-- ? TableRowAdd  编辑状态时显示输入框-->
									<FormItem prop="salesForecastRaw"
										:rules="{required: true, message: '请输入', trigger: 'blur'}">
										<Input placeholder="请输入"
											v-model.number="addSupperRowObj.salesForecastRaw"
											@input="formatSalesForecast" @on-change="calculateSalesRebateAmount()"></Input>
									</FormItem>
								</div>
								<div v-else>
									<!-- ? TableRowAdd  普通状态时显示文字-->
									{{ row.salesForecastRaw }}
								</div>
							</template>

							<!-- 销售返点比例 -->
							<template slot-scope="{ row, index }" slot="salesRebateRatioText">
								<div class="formItemArea" v-if="isModeEdit(row)">
									<!-- ? TableRowAdd  编辑状态时显示输入框-->
									<FormItem prop="salesRebateRatio">
										<!-- :rules="{validator: validateCQuantity, trigger: 'blur'}"> -->
										<Input type="number" placeholder="请输入"
											v-model.number="addSupperRowObj.salesRebateRatio"
											@on-change="calculateSalesRebateAmount()">
										<template #append><span>%</span></template>
										</Input>
									</FormItem>
								</div>
								<div v-else>
									<!-- ? TableRowAdd  普通状态时显示文字-->
									{{ row.salesRebateRatioText }}
								</div>
							</template>

							<!-- 销售返点金额 -->
							<template slot-scope="{ row, index }" slot="salesRebateAmount">
								<div class="formItemArea" v-if="isModeEdit(row)">
									<!-- ? TableRowAdd  编辑状态时显示输入框-->
									<FormItem prop="salesRebateAmount"
										:rules="{required: true, message: '请输入', trigger: 'blur',type:'number'}">
										<Input type="number" placeholder="请输入"
											v-model.number="addSupperRowObj.salesRebateAmount" disabled></Input>
									</FormItem>
								</div>
								<div v-else>
									<!-- ? TableRowAdd  普通状态时显示文字-->
									{{ row.salesRebateAmountRaw }}
								</div>
							</template>

							<!-- 节日礼品金额 -->
							<template slot-scope="{ row, index }" slot="holidayGiftAmount">
								<div class="formItemArea" v-if="isModeEdit(row)">
									<!-- ? TableRowAdd  编辑状态时显示输入框-->
									<FormItem prop="holidayGiftAmountRaw"
										:rules="{required: true, message: '请输入', trigger: 'blur'}">
										<Input placeholder="请输入"
											v-model.number="addSupperRowObj.holidayGiftAmountRaw"
											@input="formatHolidayGiftAmount" @on-change="calculateSubtotal()"></Input>
									</FormItem>
								</div>
								<div v-else>
									<!-- ? TableRowAdd  普通状态时显示文字-->
									{{ row.holidayGiftAmountRaw }}
								</div>
							</template>

							<!-- 业务费 -->
							<template slot-scope="{ row, index }" slot="operatingAmount">
								<div class="formItemArea" v-if="isModeEdit(row)">
									<!-- ? TableRowAdd  编辑状态时显示输入框-->
									<FormItem prop="operatingAmountRaw"
										:rules="{required: true, message: '请输入', trigger: 'blur'}">
										<Input placeholder="请输入"
											v-model.number="addSupperRowObj.operatingAmountRaw"
											@input="formatOperatingAmount" @on-change="calculateSubtotal()"></Input>
									</FormItem>
								</div>
								<div v-else>
									<!-- ? TableRowAdd  普通状态时显示文字-->
									{{ row.operatingAmountRaw }}
								</div>
							</template>

							<!-- 商务活动 -->
							<template slot-scope="{ row, index }" slot="businessActivityAmount">
								<div class="formItemArea" v-if="isModeEdit(row)">
									<!-- ? TableRowAdd  编辑状态时显示输入框-->
									<FormItem prop="businessActivityAmountRaw"
										:rules="{required: true, message: '请输入', trigger: 'blur'}">
										<Input placeholder="请输入"
											v-model.number="addSupperRowObj.businessActivityAmountRaw"
											@input="formatBusinessActivityAmount" @on-change="calculateSubtotal()"></Input>
									</FormItem>
								</div>
								<div v-else>
									<!-- ? TableRowAdd  普通状态时显示文字-->
									{{ row.businessActivityAmountRaw }}
								</div>
							</template>

							<!-- 小计 -->
							<template slot-scope="{ row, index }" slot="subtotal">
								<div class="formItemArea" v-if="isModeEdit(row)">
									<!-- ? TableRowAdd  编辑状态时显示输入框-->
									<FormItem prop="subtotal">
										<Input type="number" placeholder="请输入" v-model.number="addSupperRowObj.subtotal"
											disabled></Input>
									</FormItem>
								</div>
								<div v-else>
									<!-- ? TableRowAdd  普通状态时显示文字-->
									{{ row.subtotalRaw }}
								</div>
							</template>

							<!-- 操作按钮 -->
							<template slot-scope="{ row, index }" slot="action">
								<!-- ? TableRowAdd 最好使用插槽模式不要用render  columns下slot属性-->
								<!-- ? TableRowAdd 判断状态是否是新增add或者编辑edit -->
								<template v-if="row.actionType == 'add' || row.actionType == 'edit'">
									<Button type="primary" size="small"
										style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px"
										@click="saveSupperRow(row)">保存</Button>
									<Button size="small" style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px"
										@click="cancelSupperRow(row,index)">取消</Button>
								</template>
								<template v-else>
									<!-- ? TableRowAdd 当前行不为特殊状态时才显示以下操作-->
									<!-- <Button type="primary" size="small" style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px" @click="() => { itemId = row.id; isAdd = '编辑'; createShow = true; }">编辑</Button> -->
									<Button type="primary" size="small"
										style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px"
										@click="showLog(row,index)">操作日志</Button>
									<Button type="primary" size="small"
										style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px"
										@click="editSupperRow(row,index)">编辑</Button>
									<Button type="primary" size="small"
										style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px"
										@click="showCostDetail(row,index)">业务费用明细</Button>
									<Button :type="row.isUploadFile?'success':'primary'" size="small"
										style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px"
										@click="uploadZRfiles(row,index)">{{row.isUploadFile?'重新导入折让文件':'导入折让文件'}}</Button>
									<Button type="error" size="small"
										style="margin-left: 5px;margin-bottom: 5px;margin-top: 5px"
										@click="delCustomer(row)">删除</Button>
								</template>
							</template>
						</Table>
					</Form>
					<Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10"
						@on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="params.MaxResultCount"
						:current="currentPage"></Page>
				</div>
			</div>
		</Card>
		<Spin class="spin" fix v-if="spinShow" size="large">导入中...</Spin>
		<NewCustomer :value="createShow" :isAdd="isAdd" @close="close" :id="itemId" @getTab="getTab"
			:customerJMList="customerJMList" :departmentType="$constDefinition.OEM事业部" />

		<div v-if="costDetailModelShow">
			<CostDetail :show='costDetailModelShow' :customerSEBId="itemId" :departmentType="$constDefinition.OEM事业部" abort="":title="title" @close="closeModel">
			</CostDetail>
		</div>
		<!-- 导入折让文件 -->

		<Modal v-model="formZRModel" :styles="{ top: '170px', minHeight: '226px' }" :closable="false"
			:mask-closable="false" width="560" title="导入折让文件">
			<Form ref="formZR" :model="formZR">
				<FormItem prop="折让文件_Files" label="导入折让文件"
					:rules="{ required: true, message: '不能为空', trigger: 'change',type:'array' }">
					<Upload ref="uploadzr" type="drag" multiple :accept="accept" :data="uploadData" :format='format'
						:on-success="handleSuccess" :on-format-error="handleFormatError"
						:action="$constDefinition.baseUrl+'/file/UploadByCustomerZRFile'">
						<div style="padding: 0px 0">
							<Icon type="ios-cloud-upload" size="22" style="color: #3399ff"></Icon>
							<p>上传文件</p>
						</div>
					</Upload>
				</FormItem>
				<!-- 文件列表 -->
				<div class="fileList" v-if="formZR.折让文件_Files.length>0">
					<Divider plain orientation="left">已上传折让文件</Divider>
					<template v-for="(img, img_i) in formZR.折让文件_Files">
						<span :key="img_i" class="img_wrap">
							<span class="pos">
								<img class="img" :src="$constDefinition.baseUrl+ img.url" width="80px" height="80px" />
								<i class="img_magnify">
									<Icon size="26" class="ico" color="#ffffff"
										@click="handledDown(img.fileGuids,img.fileName)" type="md-arrow-down" />
									<Icon size="26" class="ico" color="#ffffff"
										@click="handleRemove(img_i,img.fileGuids)" type="ios-trash-outline" />
								</i>
							</span>
							<span class="filename" :title="img.fileName">{{img.fileName}}</span>
						</span>
					</template>
				</div>

				<Spin size="large" fix v-if="formZRLoading"></Spin>
			</Form>
			<template #footer>
				<Button @click="closeFormZRModel">关闭</Button>
				<Button type="primary" @click="uploadZRSubmit()">确定</Button>
			</template>
		</Modal>

		<Modal title="操作日志" :value="logShow" @on-ok="close()" @on-cancel="close" width="600">
			<div class="project">
				<!-- 操作日志 -->
				<Timeline>
					<TimelineItem v-for="(log,index) in form.businessLogList" :key="index">
						<p class="time">{{log.creatorName}}<span
								style="margin-left:10px;color:#b6b6b6;">{{log.creationTimeText}}</span></p>
						<p class="content">{{log.content}}</p>
					</TimelineItem>
				</Timeline>
			</div>
			<Spin size="large" fix v-show="spinShow"></Spin>
		</Modal>
	</div>

</template>

<script>
	import CostDetail from './modules/costDetail.vue'
	import Util from '../../lib/util'
	import moment from 'moment'
	import NewCustomer from './editCustomerSalesExpenseBudget.vue'
	import {
		city
	} from '../../lib/city'
	import {
		getCustomerSalesExpenseBudgetList,
		removeCustomerSalesExpenseBudget,
		createCustomerSalesExpenseBudget,
		updateCustomerSalesExpenseBudget,
		getCustomerSalesExpenseBudgetById,
		getCustomerSalesExpenseBudgetDetailInfoById
	} from '../../api/index'
	export default {
		name: 'customerSalesExpenseBudgetOEM',
		data() {
			// 自定义验证函数
			const validateCQuantity = (rule, value, callback) => {
				if (value === null || value === undefined || value === '') {
					callback(new Error('销售返点比例不能为空'));
				} else if (Number(value) === 0) {
					callback(new Error('销售返点比例不能为0'));
				} else {
					callback();
				}
			};
			return {
				list: [],
				itemId: 0,
				formZR: {
					discountsFileGuidList: [],
					折让文件_Files: [],
					id: ''
				},
				formZRLoading: false,
				formZRModel: false,
				accept: 'image/*, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
				format: ['jpg', 'pdf', 'png', 'jpeg', 'xlsx', 'xls'],
				uploadData: {
					id: this.projectId,
					// productId: this.productId,
					// type: null,
				},
				params: {
					visitedTime: [],
					visitedPerson: '',
					visitingPerson: '',
					visitedTimeStart: '',
					visitedTimeEnd: '',
					customerJM: null,
					salesman: null,
					departmentType: this.$constDefinition.OEM事业部,
					SkipCount: 0,
					MaxResultCount: 10,
				},
				requestHeader: {
					Authorization: `Bearer ${Util.abp.auth.getToken()}`,
				},
				importData: {
					departmentType: this.$constDefinition.OEM事业部,
				},
				action: this.$constDefinition.baseUrl + `/Customerfile/UploadSalesExpenseBudget?departmentType=${this.$constDefinition.OEM事业部}`,
				totalCount: 0,
				currentPage: 1,
				title: '',
				loading: false,
				form: [],
				logShow: false,
				createShow: false,
				spinShow: false,
				costDetailModelShow: false,
				contractModelShow: false,
				settlementModelShow: false,
				afterSalesModelShow: false,
				bidModelShow: false,
				isAdd: '',
				columns: [],
				cities: city,
				userData: [],
				customerJMList: [],
				salesmanList: [],
				addSupperRowObj: {
					// ? TableRowAdd 添加、编辑时的数据缓存
					customerId: 0,
					salesman: null,
					customerJM: '',
					year: null,
					yearText: '',
					salesForecast: null,
					salesForecastRaw: null,
					salesRebateRatio: null,
					salesRebateRatioRaw: null,
					salesRebateAmount: null,
					salesRebateAmountRaw: null,
					holidayGiftAmount: null,
					holidayGiftAmountRaw: null,
					operatingAmount: null,
					operatingAmountRaw: null,
					businessActivityAmount: null,
					businessActivityAmountRaw: null,
					subtotal: null,
					subtotalRaw: null,
					actionType: '',
				},
			}
		},
		components: {
			NewCustomer,
			CostDetail,
		},
		mounted() {
			this.getColumns()
			this.getTab()
		},
		created() {
			this.getSelectList()
		},
		methods: {
			formatSalesForecast(event) {
				console.log(event);
				let value = event
				if (value) {
					// 移除所有非数字和小数点的字符
					let pureValue = value.replace(/[^\d.]/g, '');
			
					// 将纯数值赋值给 this.form.salesForecast
					this.addSupperRowObj.salesForecast = pureValue;
			
					// 格式化数值，添加千位符
					let formattedValue = this.addThousandSeparator(pureValue);
					
					// 将格式化后的数值赋值给 this.addSupperRowObj.salesForecastRaw
					this.$set(this.addSupperRowObj, 'salesForecastRaw', formattedValue)
				}
			},
			formatSalesRebateAmount(event) {
				console.log(event);
				let value = event
				if (value) {
					// 移除所有非数字和小数点的字符
					let pureValue = value.replace(/[^\d.]/g, '');
			
					// 将纯数值赋值给 this.addSupperRowObj.salesRebateAmount
					this.addSupperRowObj.salesRebateAmount = pureValue;
			
					// 格式化数值，添加千位符
					let formattedValue = this.addThousandSeparator(pureValue);
					
					// 将格式化后的数值赋值给 this.addSupperRowObj.salesRebateAmountRaw
					this.$set(this.addSupperRowObj, 'salesRebateAmountRaw', formattedValue)
				}
			},
			formatHolidayGiftAmount(event) {
				console.log(event);
				let value = event
				if (value) {
					// 移除所有非数字和小数点的字符
					let pureValue = value.replace(/[^\d.]/g, '');
			
					// 将纯数值赋值给 this.addSupperRowObj.holidayGiftAmount
					this.addSupperRowObj.holidayGiftAmount = pureValue;
			
					// 格式化数值，添加千位符
					let formattedValue = this.addThousandSeparator(pureValue);
					
					// 将格式化后的数值赋值给 this.addSupperRowObj.holidayGiftAmountRaw
					this.$set(this.addSupperRowObj, 'holidayGiftAmountRaw', formattedValue)
				}
			},
			formatOperatingAmount(event) {
				console.log(event);
				let value = event
				if (value) {
					// 移除所有非数字和小数点的字符
					let pureValue = value.replace(/[^\d.]/g, '');
			
					// 将纯数值赋值给 this.addSupperRowObj.operatingAmount
					this.addSupperRowObj.operatingAmount = pureValue;
			
					// 格式化数值，添加千位符
					let formattedValue = this.addThousandSeparator(pureValue);
					
					// 将格式化后的数值赋值给 this.addSupperRowObj.operatingAmountRaw
					this.$set(this.addSupperRowObj, 'operatingAmountRaw', formattedValue)
				}
			},
			formatBusinessActivityAmount(event) {
				console.log(event);
				let value = event
				if (value) {
					// 移除所有非数字和小数点的字符
					let pureValue = value.replace(/[^\d.]/g, '');
			
					// 将纯数值赋值给 this.addSupperRowObj.businessActivityAmount
					this.addSupperRowObj.businessActivityAmount = pureValue;
			
					// 格式化数值，添加千位符
					let formattedValue = this.addThousandSeparator(pureValue);
					
					// 将格式化后的数值赋值给 this.addSupperRowObj.businessActivityAmountRaw
					this.$set(this.addSupperRowObj, 'businessActivityAmountRaw', formattedValue)
				}
			},
			formatSubtotal(event) {
				console.log(event);
				let value = event
				if (value) {
					// 移除所有非数字和小数点的字符
					let pureValue = value.replace(/[^\d.]/g, '');
			
					// 将纯数值赋值给 this.addSupperRowObj.subtotal
					this.addSupperRowObj.subtotal = pureValue;
			
					// 格式化数值，添加千位符
					let formattedValue = this.addThousandSeparator(pureValue);
					
					// 将格式化后的数值赋值给 this.addSupperRowObj.subtotalRaw
					this.$set(this.addSupperRowObj, 'subtotalRaw', formattedValue)
				}
			},
			addThousandSeparator(value) {
				// 将数值部分和小数部分分开
				let parts = value.split('.');
				// 格式化整数部分，添加千位符
				parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
				// 重新组合整数部分和小数部分
				return parts.join('.');
			},
			// 验证销售返点比例不能为空且不为 0
			validateCQuantity(rule, value, callback) {
				if (value === null || value === undefined || value === '') {
					callback(new Error('不能为空'));
				} else if (Number(value) === 0) {
					callback(new Error('不能为 0'));
				} else {
					callback();
				}
			},
			//获取表格数据
			async getTab(row) {
				// 客户管理页面
				// 获取客户信息
				const data = await getCustomerSalesExpenseBudgetList(this.params)
				this.list = data.data.result.items
				this.totalCount = data.data.result.totalCount
			},
			//   获取下拉框数据
			async getSelectList() {
				const {
					data
				} = await this.$Ajax.get(
					`/api/services/app/CustomerSalesExpenseBudgetApiService/GetInitCustomerSalesExpenseBudgetMgrInitData?departmentType=` +
					this.$constDefinition.OEM事业部
				)
				this.customerJMList = data.result.customerJMData
				this.salesmanList = data.result.salesmanData
			},
			//查询
			queryTab() {
				this.params.SkipCount = 0
				this.currentPage = 1
				this.$nextTick(() => {})
				this.getTab()
			},
			addSupper() {
				this.isAdd = '添加'
				this.createShow = true
			},
			showCostDetail(row) {
				this.itemId = row.id
				this.title = row.year + '年' + row.customerJM
				this.costDetailModelShow = true
			},
			//分页
			pageChange(size) {
				this.params.SkipCount = (size - 1) * this.params.MaxResultCount
				this.getTab()
			},
			pagesizeChange(size) {
				this.params.MaxResultCount = size
				this.getTab()
			},
			//关闭弹框
			close() {
				this.createShow = false
				this.logShow = false
			},

			//关闭弹框
			closeModel() {
				this.costDetailModelShow = false
				this.contractModelShow = false
				this.settlementModelShow = false
				this.afterSalesModelShow = false
				this.bidModelShow = false
				this.getTab()
			},
			//时间改变
			dateChange() {
				let time = this.params.visitedTime
				let start = time[0] ? this.$moment(time[0]).format('YYYY-MM-DD  HH:mm:ss') : ''
				let end = time[1] ? this.$moment(time[1]).format('YYYY-MM-DD  HH:mm:ss') : ''
				this.params.visitedTimeStart = start
				this.params.visitedTimeEnd = end
			},
			// 导入前处理
			beforeImportFile() {
				this.spinShow = true
			},
			// 导入成功
			importFile() {
				this.$Message.success({
					content: '导入成功',
					duration: 3,
				})
				this.getTab()
				this.spinShow = false
			},
			// 导入失败
			errorImportFile(error, file, fileList) {
				this.$Message.error({
					content: file.error.message,
					duration: 3,
				})
				this.getTab()
				this.spinShow = false
			},
			// 下载导入模板
			downLoadTemplate() {
				this.downloadFile('/Customerfile/DownloadSalesExpenseBudgetModel', '导入客户销售费用预算模板')
			},
			handledDown(guid, fileName) {
				let nameSuffix = this.getExtension(fileName)
				this.$downLoad('/files/downloadFile_Path/' + guid, '折让文件', '.' + nameSuffix)
			},
			getExtension(fileName) {
				return fileName.slice(((fileName.lastIndexOf('.') - 1) >>> 0) + 2)
			},
			// 导入折让文件
			uploadZRfiles(data, i) {
				console.log('🚀 ~ uploadZRfiles ~ data:', data)
				this.$refs['formZR'].resetFields()
				this.uploadData.id = data.id
				this.formZRModel = true
				//   if (data.isUploadFile) {
				this.formZRLoading = true

				// 上传过
				this.getLastUploadZRfile(data.id)
				//   }
			},
			async getLastUploadZRfile(id) {
				const {
					data
				} = await this.$Ajax.get(
					`/api/services/app/CustomerSalesExpenseBudgetApiService/GetFileById?id=` + id
				)

				this.formZR = data.result
				this.formZRLoading = false
			},
			//移除文件
			async handleRemove(index, guid) {
				console.log('🚀 ~ file: uploadHTModel.vue:124 ~ handleRemove ~ guid:', guid)
				try {
					const {
						data
					} = await this.$Ajax.delete(
						`/api/services/app/ComFile/DeleteFileByGuid?guid=${guid}`
					)
					this.formZR.折让文件_Files.splice(index, 1)
				} catch (error) {
					this.$Message.error({
						content: '删除失败',
					})
				}
			},
			//文件格式错误
			handleFormatError(file) {
				this.$Notice.warning({
					title: '文件格式错误',
					// desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
				})
			},
			//文件上传成功
			handleSuccess(e) {
				this.formZR.折让文件_Files.push(e.result)
				this.$refs.formZR.validateField('折让文件_Files')
				this.$refs.uploadzr.clearFiles()
				// console.log(this.$refs.upload.clearFiles());
			},
			//导入折让文件提交
			uploadZRSubmit() {
				this.$refs.formZR.validate(async (valid) => {
					if (valid) {
						this.formZRLoading = true
						if (this.formZR.折让文件_Files.length > 0) {
							let files = []
							this.formZR.折让文件_Files.map((file) => {
								files.push(file.fileGuids)
							})
							this.formZR.discountsFileGuidList = files //.join(',')
						}
						let {
							data
						} = await this.$Ajax.post(
							'/api/services/app/CustomerSalesExpenseBudgetApiService/SubmitFiles',
							this.formZR
						)
						this.$Message.success({
							content: '操作成功',
							background: true,
							duration: 6,
						})
						this.getTab()
						this.closeFormZRModel()
					} else {
						this.$Message.error('请将上传文件!')
					}
				})
			},
			//取消导入折让文件
			closeFormZRModel() {
				this.formZRModel = false
				this.formZR = {
					id: '',
					discountsFileGuidList: [],
					折让文件_Files: []
				}
				this.formZRLoading = false
			},
			downloadFile(url, title) {
				const date = moment(new Date()).format('yyyyMMDDHHmm')
				let _this = this
				let consturl = this.$constDefinition.baseUrl + url //下载地址url
				var xhr = new XMLHttpRequest()
				xhr.open('get', consturl, true) // get、post都可
				xhr.responseType = 'blob'
				xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`) //加请求头
				xhr.onload = function() {
					console.log(xhr)
					if (xhr.status == 200) {
						let blob = new Blob([this.response], {
							type: 'application/vnd.ms-excel',
						})
						var a = document.createElement('a')
						var url = window.URL.createObjectURL(blob)
						a.href = url
						a.download = title + date + '.xlsx' // 文件名
						if (xhr.readyState === 4) {
							_this.$Message.success({
								content: '下载成功',
								duration: 3,
							})
						}
					} else {
						_this.$Message.error({
							content: '下载失败',
							duration: 3,
						})
					}
					a.click()
					window.URL.revokeObjectURL(url)
				}
				xhr.send()
			},
			exportFile() {
				var _this = this
				this.$downLoad(
					'/api/Export/ExportCustomerSalesExpenseBudget',
					'客户销售费用预算',
					'.xlsx',
					this.params
				)
			},
			async getInfo() {
				const {
					data
				} = await this.$Ajax.get(
					`/api/services/app/CustomerSalesExpenseBudgetApiService/GetInfoInitData?customerJM=${this.addSupperRowObj.customerJM}&departmentType=` +
					this.$constDefinition.OEM事业部
				)
				this.addSupperRowObj.salesman = data.result.salesman
			},
			//表格
			getColumns() {
				// ? TableRowAdd 改插槽模式 slot: 'action',与table元素下slot保持一致
				let _this = this
				this.columns = [{
						title: '客户简名',
						slot: 'customerJM',
						width: 160,
					},
					{
						title: '业务员',
						slot: 'salesmanText',
						width: 160,
					},
					{
						title: '年份',
						slot: 'year',
						width: 120,
					},
					{
						title: '销售预估',
						slot: 'salesForecastText',
						width: 150,
					},
					{
						title: '销售返点比例',
						slot: 'salesRebateRatioText',
						width: 150,
					},
					{
						title: '销售返点金额',
						slot: 'salesRebateAmount',
						width: 150,
					},
					{
						title: '节日礼品金额',
						slot: 'holidayGiftAmount',
						width: 150,
					},
					{
						title: '业务费',
						slot: 'operatingAmount',
						width: 150,
					},
					{
						title: '商务活动',
						slot: 'businessActivityAmount',
						width: 150,
					},
					{
						title: '小计',
						slot: 'subtotal',
						width: 120,
					},
					// ? TableRowAdd 改插槽模式 slot: 'action',与table元素下slot保持一致
					{
						title: '操作',
						align: 'left',
						width: 240,
						slot: 'action',
					},
				]
			},
			// ? TableRowAdd 判断是否处于编辑状态
			isModeEdit(row) {
				if (row.actionType == 'add' || row.actionType == 'edit') {
					return true
				} else {
					return false
				}
			},
			// ? TableRowAdd 添加 添加一行
			addSupperRow() {
				// 判断是否有正处于编辑状态的数据
				if (
					this.list.some((item) => {
						return item.actionType === 'edit' || item.actionType === 'add'
					})
				) {
					//有正处于编辑状态的数据
					this.$Message.error({
						content: '请先保存添加的数据',
						duration: 3,
					})
					return
				}
				this.clearSupperObj() //重置一下添加
				this.addSupperRowObj.actionType = 'add' //操作状态 添加add 编辑edit
				this.addSupperRowObj.departmentType = this.$constDefinition.OEM事业部
				this.list.unshift(this.addSupperRowObj) //在数据最前面添加一行空行
			},
			editSupperRow(row, index) {
				// 判断是否有正处于编辑状态的数据
				//判断是否处于编辑状态
				if (
					this.list.some((item) => {
						return item.actionType === 'edit' || item.actionType === 'add'
					})
				) {
					//有正处于编辑状态的数据
					this.$Message.error({
						content: '请先保存添加的数据',
						duration: 3,
					})
					return
				}
				this.$set(this.list[index], 'actionType', 'edit') //通过下标使用set方法加上操作状态 添加add 编辑edit
				let data = JSON.parse(JSON.stringify(row)) //转换一下使两份数据不指向同一内存地址(深拷贝)
				data.yearText = new Date(row.year + '')
				this.addSupperRowObj = data //编辑时把数据存起来
			},
			// ? TableRowAdd 取消添加/更改
			cancelSupperRow(row, index) {
				// 判断是添加还是编辑
				if (row.actionType == 'add') {
					//添加时直接删除
					this.list.shift() //在数据最前面删除一行
				} else {
					//编辑时还原数据
					this.$set(this.list[index], 'actionType', '') //还原操作状态
				}
				this.clearSupperObj()
			},
			// ? TableRowAdd 添加编辑保存
			saveSupperRow(row) {
				// formAddSupperRowObj确保不要有同样的ref否则$refs找不到
				this.$refs['formAddSupperRowObj'].validate(async (valid) => {
					if (valid) {
						this.addSupperRowObj.year = this.$moment(this.addSupperRowObj.yearText).format('YYYY')
						// 判断是添加还是编辑
						if (row.actionType == 'add') {
							//添加时
							try {
								const data = await createCustomerSalesExpenseBudget(this.addSupperRowObj)
								if (data.data.success) {
									this.$Message.success('添加成功')
									this.getTab()
								} else {
									this.$Message.error('添加失败')
								}
							} catch (error) {
								this.$Message.error('添加失败')
							}
						} else {
							//编辑时
							try {
								const data = await updateCustomerSalesExpenseBudget(this.addSupperRowObj)
								if (data.data.success) {
									this.$Message.success('编辑成功')
									this.getTab()
								} else {
									this.$Message.error('编辑失败')
								}
							} catch (error) {
								this.$Message.error('编辑失败')
							}
						}
					} else {
						this.$Message.error('请按要求输入信息！')
					}
				})
			},

			// ? TableRowAdd 清空缓存数据
			clearSupperObj() {
				this.addSupperRowObj = {
					customerId: 0,
					salesman: null,
					customerJM: '',
					year: null,
					salesForecast: null,
					salesRebateRatio: null,
					salesRebateAmount: null,
					holidayGiftAmount: null,
					operatingAmount: null,
					businessActivityAmount: null,
					subtotal: null,
					actionType: '',
				}
			},
			async showLog(row) {
				this.logShow = true
				const data = await getCustomerSalesExpenseBudgetDetailInfoById({
					id: row.id
				})
				this.form = {
					...data.data.result
				}
				console.log(this.form);
				this.spinShow = false
			},
			//删除
			delCustomer(row) {
				this.$Modal.confirm({
					title: '确定删除数据？',
					content: '删除后不可撤销',
					okText: '确认',
					cancelText: '取消',
					onOk: async () => {
						let res = await removeCustomerSalesExpenseBudget(row.id)
						if (res.data.success) {
							this.$Message.success('删除成功')
						} else {
							this.$Message.success('删除失败')
						}
						this.getTab()
					},
				})
			},
			calculateSalesRebateAmount() {
				if (this.addSupperRowObj.salesRebateRatio == null || this.addSupperRowObj.salesRebateRatio == '')
					this.addSupperRowObj.salesRebateRatio = 0
				if (
					this.addSupperRowObj.salesForecast != null &&
					this.addSupperRowObj.salesForecast != ''
				) {
					this.addSupperRowObj.salesRebateAmount =
						(this.addSupperRowObj.salesForecast * this.addSupperRowObj.salesRebateRatio) / 100
					this.calculateSubtotal()
					console.log(this.addSupperRowObj, "测试123");
				} else {
					this.addSupperRowObj.salesRebateAmount = null
				}
			},
			calculateSubtotal() {
				console.log(
					this.addSupperRowObj.holidayGiftAmount != null,
					this.addSupperRowObj.holidayGiftAmount,
					'节日礼品金额'
				)
				var newSalesRebateAmount = null
				var newHolidayGiftAmount = null
				var newOperatingAmount = null
				var newBusinessActivityAmount = null
				if (
					this.addSupperRowObj.salesRebateAmount == null ||
					this.addSupperRowObj.salesRebateAmount == ''
				) {
					newSalesRebateAmount = 0
				} else {
					newSalesRebateAmount = parseFloat(this.addSupperRowObj.salesRebateAmount)
				}
				if (
					this.addSupperRowObj.holidayGiftAmount == null ||
					this.addSupperRowObj.holidayGiftAmount == ''
				) {
					newHolidayGiftAmount = 0
				} else {
					newHolidayGiftAmount = parseFloat(this.addSupperRowObj.holidayGiftAmount)
				}
				if (
					this.addSupperRowObj.operatingAmount == null ||
					this.addSupperRowObj.operatingAmount == ''
				) {
					newOperatingAmount = 0
				} else {
					newOperatingAmount = parseFloat(this.addSupperRowObj.operatingAmount)
				}
				if (
					this.addSupperRowObj.businessActivityAmount == null ||
					this.addSupperRowObj.businessActivityAmount == ''
				) {
					newBusinessActivityAmount = 0
				} else {
					newBusinessActivityAmount = parseFloat(this.addSupperRowObj.businessActivityAmount)
				}

				this.addSupperRowObj.subtotal =
					newSalesRebateAmount + newHolidayGiftAmount + newOperatingAmount + newBusinessActivityAmount
			},
		},
	}
</script>

<style scoped lang="less">
	.app {
		min-width: 1260px;
	}

	/deep/ .ivu-table-expanded-cell {
		padding: 0;
		padding-left: 50px;
	}

	/deep/.ivu-form-item {
		margin-bottom: 10px;
	}

	/deep/.ivu-form-item-error {
		margin-bottom: 20px;
	}

	.formItemArea {
		margin-top: 10px;
	}

	.dt {
		display: flex;
		justify-content: center;
		max-width: 100%;
	}

	.fileList {
		display: flex;
		flex-wrap: wrap;

		.filename {
			width: 80px;
			word-break: break-all;
			text-overflow: -o-ellipsis-lastline;
			overflow: hidden; //溢出内容隐藏
			text-overflow: ellipsis; //文本溢出部分用省略号表示
			display: -webkit-box; //特别显示模式
			-webkit-line-clamp: 2; //行数
			line-clamp: 2;
			-webkit-box-orient: vertical; //盒子中内容竖直排列
		}
	}

	.img {
		margin-right: 10px;
	}

	.pos {
		position: relative;
	}

	.pos:hover .img_magnify {
		display: flex;
		justify-content: space-around;
	}

	.ico {
		position: relative;
		top: 50%;
		transform: translate(0%, -20%);
	}

	.img_magnify {
		display: none;
		background: rgba(0, 0, 0, 0.459);
		position: absolute;
		z-index: 1;
		width: 80px;
		height: 80px;
		left: 0px;
		right: 0;
		top: 0;
		bottom: 0;
	}

	.img_wrap {
		display: flex;
		flex-direction: column;
		padding: 5px 0px;
	}
</style>